import { MainTemplate } from '../templates/MainTemplate';
import { useTheme } from '../contexts/ThemeProvider';
import { Button, HStack, VStack } from '@chakra-ui/react';
import { Label } from '../components/atoms/Label';
import { Search } from '../components/molecules/Search';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { ActivityGrid } from '../components/molecules/ActivityGrid';
import React from 'react';
import { Footer } from '../components/organisms/Footer';

export function SearchPage() {
  const { colors } = useTheme();
  const navigate = useNavigate();
  const [search, setSearch] = React.useState('');

  return (
    <MainTemplate>
      <VStack
        align={'self-start'}
        width="90%"
        marginBottom={{
          base: '100px',
          md: '0px',
        }}
        paddingTop={'20px'}
        spacing={6}
      >
        <HStack>
          <Button variant={'link'} onClick={() => navigate(-1)} gap={2}>
            <FaArrowLeftLong color={colors.primaryColor} />
          </Button>
          <Label>Pesquisar</Label>
        </HStack>

        <Search value={search} onChange={setSearch} />
        <ActivityGrid column search={search} />
        <Footer />
      </VStack>
    </MainTemplate>
  );
}
